
export enum NoteTableName {
  Charge = 'Charge', 
  Checklist = 'Checklist',
  Client = 'Client',
  Company = 'Company',
  Contact = 'Contact',
  Debtor = 'Debtor',
  Document = 'Document',
  FuelUsage = 'Fuel Usage', 
  IFTA = 'IFTA', 
  IFTAReadyToFile = 'IFTA Ready To File Audit',
  Invoice = 'Invoice', 
  InvoiceAdjustment = 'Invoice Adjustment',
  InvoiceArchive = 'Invoice Archive',
  InvoiceDetail = 'Invoice Detail', 
  Note = 'Note',
  Payment = 'Payment', 
  Recovery = 'Recovery',
  Task = 'Task',
  User = 'User',
  UserActivity = 'User Activity',
  Vendor = 'Vendor',
  VendorCompany = 'VendorCompany',
  VendorFee = 'VendorFee',
  Workflow = 'Workflow', 
  WorkflowDetail = 'Workflow Detail', 
  WorkflowDetailTask = 'Workflow Detail Task',
  WorkflowInvoiceAdjustment = 'Workflow Invoice Adjustment'
}

export enum UnitMTRStates {
  Connecticut = 8, 
  Idaho = 13, 
  Kentucky = 17, 
  NewMexico = 35, 
  NewYork = 38,
  Oregon = 42
}

export enum CompanyServiceTypes {
  SCACCode = 1013, 
  HAZMATRenewal = 1002, 
  NMMTRRenewal = 1005, 
  NYHUTMTRRenewal = 1004, 
  Service2290 = 2, 
  SafetyService = 1015
}

export enum CompanyServiceTypeNames {
  SCACCode = 'SCAC Code', 
  HAZMATRenewal = 'HAZMAT Renewal',
  NMMTRRenewal = 'NM MTR Renewal',
  NYHUTMTRRenewal = 'NY HUT MTR Renewal'
}


// WEBPACK FOOTER //
// ./src/app/shared/models/enums.ts